import { type Country } from 'api/@types/Country';
import { FormattedMessage } from 'react-intl';

import countryMessages from './localizedCountryMessages';

interface LocalizedCountryProps {
  countryIsoCode: Country['isoCode'];
}

export const LocalizedCountry = ({ countryIsoCode }: LocalizedCountryProps) => {
  const countryMessage = countryMessages?.[countryIsoCode];

  return <>{countryMessage ? <FormattedMessage {...countryMessage} /> : countryIsoCode} </>;
};

export default LocalizedCountry;
